import styled from 'styled-components';

import { Column } from '../Column';

export const Wrapper = styled(Column)``;
